import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { NerriSessionAccessesMetadata } from "../../api/auth/model/session.metadata";
import { AppQuery } from "../../store/app.query";
import { AppService } from "../../store/app.service";
import { UnauthorizedQuery } from "./store/unauthorized.query";
import { UnauthorizedService } from "./store/unauthorized.service";

@Component({
    selector: "nerri-unauthorized",
    standalone: false,
    templateUrl: "unauthorized.template.html",
    styleUrls: ["unauthorized.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class UnauthorizedComponent implements OnInit {
    public organisation$ = this.appQuery.organisation$;
    public session$ = this.query.selectSession();

    constructor(
        private query: UnauthorizedQuery,
        private appQuery: AppQuery,
        private service: UnauthorizedService,
        private appService: AppService,
        private router: Router
    ) {}

    public ngOnInit(): void {
        this.service.loadSessionInfo().subscribe();

        const { authorized } = this.appQuery.getValue();
        if (authorized !== null) {
            return;
        }

        this.appService.loadCurrentAccount().subscribe(() => {
            const { currentAccount } = this.appQuery.getValue();
            if (currentAccount) {
                this.router.navigate(["/dashboard"]);
            }
        });
    }

    public redirect(access: NerriSessionAccessesMetadata): void {
        if (!access.product?.url) {
            return;
        }

        window.location.href = access.product.url;
    }
}
